import { findDeclareTypeById, universalBasicTypeFactory } from '../../../../utilsTs/declareTypes';
import AntDraggableModal from '../../../universal/AntDraggableModal';
import BaseLogger, { BaseLoggerProps } from './BaseLogger';

/** 日志属性 */
export interface BaseWebUniversalLoggerProps<
    F extends universalBasicTypeFactory<any> = universalBasicTypeFactory<any>
> extends BaseLoggerProps<F> {
    /** 关闭窗口 */
    closeModal: () => void
};

const BaseWebUniversalLogger = (props: BaseWebUniversalLoggerProps) => {
    const { loggerTypeId = 'SYSTEM', LoggerTypes,
        queryType, queryId, closeModal } = props;
    const loggerType = findDeclareTypeById(LoggerTypes?.getAll() ?? [], loggerTypeId);
    const titleName = `${queryType}${queryId ? '-' + queryId : ''}`
    return (
        <>
            <AntDraggableModal
                title={`${loggerType?.name ? loggerType.name : ''}【${titleName}】日志`}
                open={true}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1080}
            >
                <BaseLogger {...props} />
            </AntDraggableModal>
        </>
    )
}

export default BaseWebUniversalLogger;